<template>
  <section class="section__3">
    <div class="text__content__container">
      <div class="main__title">
        <h1>
          Create the <br />
          Future with Us
        </h1>
      </div>
    </div>
    <hr />
    <p>
      Every day we’re building better tools for communicating with the brain.
      With the right team, the applications for this technology are limitless.
    </p>
    <div class="link__container">
      <a href="#" class="link__item">REACH OUT</a>
      <img class="right__arrow" src="../../assets/right-arrow.png" alt="icon" />
    </div>
  </section>
</template>

<script>
export default {
  name: "Section_3",
};
</script>

<style scoped>
@media only screen and (min-width: 601px) {
  h1,
  h2,
  h3 {
    margin: 0;
  }
  .section__3 {
    padding: 3.5rem;
    background-image: url("https://d33wubrfki0l68.cloudfront.net/images/pages/adda9c994370b8bf704622762626be991fc29c0d/homepage-footer.jpg");
    background-position-x: center;
    background-position-y: top;
    background-attachment: scroll;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .main__title > h1 {
    color: white;
    font-size: 42px;
    text-align: start;
    font-family: "Times New Roman", Times, serif;
    font-weight: lighter;
  }
  hr {
    border: 1px solid white;
    margin: 0;
    width: 30%;
  }
  .text__content__container {
    margin-bottom: 2rem;
  }
  p {
    color: white;
    max-width: 30ch;
    font-size: 18px;
    line-height: 24px;
    font-family: "Average Sans", sans-serif;
    margin-bottom: 17rem;
  }
  .link__container {
    display: flex;
    align-items: center;
  }
  .right__arrow {
    width: 15px;
    height: 20px;
    filter: invert(100);
  }
  .link__item {
    margin-right: 0.5rem;
    font-family: "Barlow", sans-serif;
    color: white;
    font-size: 20px;
    font-weight: bold;
  }
}
/* mobile responsive menu */
@media only screen and (max-width: 600px) {
  h1,
  h2,
  h3 {
    margin: 0;
  }
  .section__3 {
    height: calc(2.08 * 500px);
    padding-top: 1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 0;
    background-image: url("https://d33wubrfki0l68.cloudfront.net/ceecb3a0de315a6222f8b40d9570f479ba6dc04b/b52e3/images/pages/homepage-footer-mobile.png");
    /* background-position-x: top;
    background-position-y: center; */
    background-position: center;
    /* background-attachment: scroll; */
    background-repeat: no-repeat;
    background-size: cover;
  }
  .main__title > h1 {
    color: white;
    font-size: 42px;
    text-align: start;
    font-family: "Times New Roman", Times, serif;
    font-weight: lighter;
  }
  hr {
    border: 1px solid white;
    margin: 0;
    width: 30%;
  }
  .text__content__container {
    margin-bottom: 2rem;
  }
  p {
    color: white;
    max-width: 30ch;
    font-size: 18px;
    line-height: 24px;
    font-family: "Average Sans", sans-serif;
    margin-bottom: 43rem;
  }
  .link__container {
    display: flex;
    align-items: center;
  }
  .right__arrow {
    width: 15px;
    height: 20px;
    filter: invert(100);
  }
  .link__item {
    margin-right: 0.5rem;
    font-family: "Barlow", sans-serif;
    color: white;
    font-size: 20px;
    font-weight: bold;
  }
}
</style>
